import FatalErrorScreen from './screens/FatalErrorScreen';
import Error404Screen from './screens/Error404Screen';

export { Error404Screen, FatalErrorScreen };



// WEBPACK FOOTER //
// ./src/_app/errors/index.js